import React, { useState } from 'react';
import './NavMenu.css';

const NavMenu = () => {
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    return (
        <nav className="navigation navbar navbar-expand-lg">
            <div className="container">
                <div className="navbar-grid">
                    <div className="nav-section left">
                        <a href="/Our-Story" className="nav-link">Our Story</a>
                        <a href="/Memorial" className="nav-link active" aria-current="page">Memorial</a>
                        <a href="/News" className="nav-link">News & Events</a>
                    </div>
                    <div className="nav-section center">
                        <a href="/" className="navbar-brand">The Underhill Family</a>
                    </div>
                    <div className="nav-section right">
                        <a href="/Photo-Album" className="nav-link">Photo Album</a>
                        <a href="/Committee" className="nav-link">Committee</a>
                        <a href="/Payment">
                            <button className="btn btn-primary">Payment</button>
                        </a>
                    </div>
                    <div className="nav-section hamburger">
                        <i className="fa fa-bars" onClick={toggleDropdown}></i>
                    </div>
                </div>
                <div className={`drop-menu ${dropdownVisible ? 'visible' : ''}`}>
                    <a href="/Our-Story" className="nav-link">Our Story</a>
                    <a href="/Memorial" className="nav-link active" aria-current="page">Memorial</a>
                    <a href="/News" className="nav-link">News & Events</a>
                    <a href="/Photo-Album" className="nav-link">Photo Album</a>
                    <a href="/Committee" className="nav-link">Committee</a>
                    <a href="/Payment" className="nav-link">Payment</a>
                </div>
            </div>
        </nav>
    );
};

export default NavMenu;
